import { useState, useEffect } from 'react';
import { Cookie, Shield } from 'lucide-react';

interface CookieConsentProps {
  onConsentChange: (consent: boolean) => void;
}

export default function CookieConsent({ onConsentChange }: CookieConsentProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [lang] = useState(() =>
    (typeof window !== 'undefined' ? (localStorage.getItem('plinus-language') as 'ru' | 'en') || 'ru' : 'ru')
  );

  useEffect(() => {
    // Проверяем, есть ли уже сохраненное согласие
    const savedConsent = localStorage.getItem('cookie-consent');
    if (savedConsent === null) {
      // Если согласие не дано, показываем блок
      setIsVisible(true);
      setIsAnimating(true);
    } else {
      // Если согласие уже дано, уведомляем родительский компонент
      onConsentChange(savedConsent === 'accepted');
    }
  }, [onConsentChange]);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      onConsentChange(true);
    }, 300);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-sm border-t border-gray-700/50 transition-all duration-300 ${
        isAnimating ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="flex-shrink-0 mt-1">
              <Cookie className="w-5 h-5 text-blue-400" />
            </div>
            <div className="flex-1">
              <h3 className="text-white font-medium text-sm mb-1">
                Мы используем cookies
              </h3>
              <p className="text-gray-300 text-xs leading-relaxed">
                Используя сайт, вы соглашаетесь с{' '}
                <a
                  href={`/${lang}/privacy-policy`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 underline"
                >
                  обработкой данных
                </a>
                {' '}с целью сбора аналитики. Cookies можно отключить в любой момент в настройках вашего браузера.
              </p>
            </div>
          </div>
          
          <div className="flex items-center flex-shrink-0">
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-200 rounded-md flex items-center gap-1"
            >
              <Shield className="w-3 h-3" />
              Хорошо
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
